import {
  Globe2,
  Link2,
  NetworkIcon,
  PanelTopClose,
  Sparkles,
  Target,
} from "lucide-react";
import React from "react";
import "../App.css";
import EventCard from "../components/EventCart";
import FAQs from "../components/FAQs";
import FrequentEvents from "../components/FrequentEvents";
import GetInTouch from "../components/GetInTounch";
import HeroSection from "../components/HeroSection";

const Home = () => {
  return (
    <div className="bg-gray-50">
      <HeroSection />
      {/* What Defines Us */}

      <section id="defines" className="bg-gray-100 py-8">
  <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
    <h2 className="text-4xl font-bold text-center mb-8 text-indigo-700">
      What Defines Us
    </h2>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Card 1 */}
      <div className="bg-white shadow-sm rounded-lg p-6 hover:transform hover:scale-105 transition-transform duration-300">
        <h3 className="text-2xl font-bold mb-2 text-tomato">
          Our Vision
        </h3>
        <p className="text-lg text-gray-700 line-clamp-6 overflow-hidden sm:line-clamp-none sm:overflow-visible">
          To build a robust and vibrant committee of Gambian students in
          India, strengthen bilateral relationships, and develop an
          independent institution that caters to the welfare and
          well-being of its members.
        </p>
      </div>

      {/* Card 2 */}
      <div className="bg-white shadow-sm rounded-lg p-6 hover:transform hover:scale-105 transition-transform duration-300">
        <h3 className="text-2xl font-bold mb-2 text-tomato">
          Our Mission
        </h3>
        <p className="text-lg text-justify text-gray-700 line-clamp-6 overflow-hidden sm:line-clamp-none sm:overflow-visible">
          The association will support, defend, and improve the welfare of
          all Gambian students in India, addressing academic and social
          issues, and striving to guarantee stability.
        </p>
      </div>

      {/* Card 3 - Spanning two columns */}
      <div className="md:col-span-2 bg-white shadow-sm rounded-lg p-6 hover:transform hover:scale-105 transition-transform duration-300">
        <h3 className="text-2xl font-bold mb-2 text-tomato">
          Aim & Objective
        </h3>
        <p className="text-lg text-gray-700 line-clamp-7 overflow-hidden sm:line-clamp-none sm:overflow-visible">
          The fundamental aims and objectives of the Association shall be
          to synergize all Gambian students in India under one umbrella
          and promote the culture of The Gambia in India. The association
          aims to offer skills training, community service, and other
          development activities to help members realize their full
          potential and become self-reliant.
        </p>
      </div>
    </div>
  </div>
</section>
      
      {/* Key Features */}
      <section className="py-10 bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-center mb-12 text-indigo-700">
            Why Join Us?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <FeatureCard
              icon={<Globe2 className="w-12 h-12 text-tomato" />}
              title="Cultural Exchange & Promotion"
              description="Celebrate diversity, bridging students through shared experiences and mutual understanding"
              // description="Be part of a vibrant Gambian student community in India."
            />
            <FeatureCard
              icon={<PanelTopClose className="w-12 h-12 text-tomato" />}
              title="Support Network"
              description="Find solace and strength in a united community, navigating challenges together while fostering collective growth."
            />

            <FeatureCard
              icon={<Link2 className="w-12 h-12 text-tomato" />}
              title="Students Connections"
              description="Engage with influential networks, opening doors to opportunities that transcend borders and shape futures."
            />
            <FeatureCard
              icon={<Sparkles className="w-12 h-12 text-tomato" />}
              title="Social Responsibility"
              description="Be a catalyst for positive change, contributing to the welfare of your peers and leaving a lasting impact."
            />
            <FeatureCard
              icon={<NetworkIcon className="w-12 h-12 text-tomato" />}
              title="Networking Opportunities"
              description="Weave a tapestry of connections that spans continents and opens doors to future prospects."
            />
            <FeatureCard
              icon={<Target className="w-12 h-12 text-tomato" />}
              title="Leadership Development"
              description="Hone your talents and discover your leadership potential, equipping yourself with invaluable skills for tomorrow's challenges."
            />
          </div>
        </div>
      </section>

      {/* Upcoming Events */}
      <FrequentEvents />

      {/* GetInTouch Section */}
      <GetInTouch />

      {/* FAQs Section */}
      <section className="py-10 bg-grey-100">
        <div className="w-full max-w-7xl mx-auto p-6 bg-white rounded-lg shadow-md">
          {/* Updated width */}
          <h2 className="text-3xl font-bold text-center mb-8 text-indigo-700">
            Frequently Asked Questions, FAQs
          </h2>
          <FAQs />
        </div>
      </section>

    </div>
  );
};

// Reusable FeatureCard component
const FeatureCard = ({ icon, title, description }) => (
  <div className="bg-white p-4 rounded-lg shadow-sm  hover:shadow-md transition-shadow duration-300 max-w-sm h-54 relative">
    <div className="flex justify-center mb-2">{icon}</div>
    <h3 className="text-xl font-semibold mb-2 text-center">{title}</h3>
    <p className="text-gray-600 text-center line-clamp-6 overflow-hidden">{description}</p>
  </div>
);

<EventCard />;

export default Home;
